"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _Image = _interopRequireWildcard(require("../../Image"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default(props) {
  var _props$invert = props.invert,
    invert = _props$invert === void 0 ? false : _props$invert;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var src = (0, _react.useMemo)(function () {
    var src = props.src;
    if (!!src && src !== t('onmail.png')) {
      return src;
    }
    return (0, _Image.withThemeSrc)(props.invert ? t('onmail-light.png') : t('onmail.png'), t('onmail-light.png'));
  }, [props.src, invert]);
  return /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    className: "object-contain",
    src: src,
    alt: "onmail"
  });
};
//# sourceMappingURL=AppLogo.js.map